<template>
  <div class="BarChartDisplay">
    <Card :title="title">
      <barChart
        class="BarChart"
        :width="500"
        type="bar"
        :options="options"
        :series="series"
        v-if="isVisible"
      />
    </Card>
  </div>
</template>

<script>
import barChart from 'vue-apexcharts';

import Card from './Card';

export default {
  name: 'BarChartDisplay',
  components: {
    Card,
    barChart,
  },
  computed: {
    isVisible() {
      return this.series.length !== 0
    }
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    series: {
      type: Array,
      required: true,
      default: () => ([]),
    },
  },
};
</script>

<style lang="scss"></style>
